module.exports = __webpack_public_path__ + "post-listing-block-2-image-I6l4GKM.jpg";